import React from 'react';
import './driverShift.css';
import { m } from '../../utils';

const DriverShift = ({ booking }) => (
  <div className="user-container">
    <div className="user-info-block">
      <h4>
        Name:{' '}
        <span>
          {booking.first_name} {booking.last_name}
        </span>
      </h4>
      <h4>
        Booking Time: <span>{m(booking.datetime).format('MMMM Do YYYY, h a')}</span>
      </h4>
      <h4>
        Plate: <span>{booking.plate}</span>
      </h4>
    </div>
    <div className="dialog-image-cropper">
      <img alt="profile" src={booking.profile_image} className="dialog-profile-image" />
    </div>
  </div>
);

export default DriverShift;



// WEBPACK FOOTER //
// ./src/components/Parking/DriverShift.js